var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#888",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5355 11.3682L15.7118 11.1328C16.8671 9.52695 17.0312 7.90211 17.0312 7.03125C17.0312 3.15035 13.8861 0 10 0C6.1191 0 2.96875 3.14516 2.96875 7.03125C2.96875 7.9023 3.13273 9.52672 4.28824 11.1328L3.46449 11.3682C0.83125 12.1205 0 14.5152 0 15.9611V16.9643C0 18.6382 1.3618 20 3.0357 20H16.9643C18.6382 20 20 18.6382 20 16.9643V15.9611C20 14.5452 19.1904 12.1267 16.5355 11.3682ZM10 1.875C12.8477 1.875 15.1562 4.18355 15.1562 7.03125C15.1562 9.87895 12.8477 12.1875 10 12.1875C7.15227 12.1875 4.84375 9.87895 4.84375 7.03125C4.84375 4.18355 7.15227 1.875 10 1.875ZM18.125 16.9643C18.125 17.6053 17.6053 18.125 16.9643 18.125H3.0357C2.39469 18.125 1.875 17.6053 1.875 16.9643V15.9611C1.875 14.6655 2.73387 13.5269 3.97961 13.171L5.78051 12.6565C6.3548 13.0882 7.82918 14.0625 10 14.0625C12.1708 14.0625 13.6452 13.0882 14.2195 12.6565L16.0204 13.171C17.2661 13.527 18.125 14.6655 18.125 15.9611V16.9643Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.dde79d41a8aad8ef77ddde03ff23f546.svg";
export { ForwardRef as ReactComponent };